// Mock data for Asray Shibu's portfolio website
// This file centralizes all portfolio data for easy backend integration later

export const personalInfo = {
  name: "Asray Shibu",
  firstName: "Asray",
  lastName: "Shibu",
  role: "Aspiring Software Developer",
  tagline: "BCA Student | IoT Enthusiast | Building the Future with Code",
  shortBio: "Passionate software developer and BCA student at Amrita Vishwa Vidyapeetham with a keen interest in IoT, embedded systems, and full-stack development. I love building solutions that bridge the physical and digital worlds.",
  location: "Kerala, India",
  email: "asray8@gmail.com",
  phone: "+91 8590321656",
  nationality: "Indian",
  resumeUrl: "/assets/resume.pdf",
  social: {
    linkedin: "https://www.linkedin.com/in/asray-shibu-6148b523b",
    github: "https://github.com/Asraaaay",
  },
  languages: ["English", "Malayalam", "Hindi"],
};

export const aboutMe = {
  bio: [
    "I'm a BCA student at Amrita Vishwa Vidyapeetham with a strong foundation in programming and a genuine passion for technology. My journey started with curiosity about how things work, which naturally led me to software development and IoT systems.",
    "I specialize in building practical solutions using Python, Java, C++, and web technologies. My projects in IoT—from fire safety systems to smart bus tracking—reflect my belief that technology should solve real-world problems.",
    "When I'm not coding, you'll find me on the football field, exploring new tech on YouTube, or tinkering with embedded systems. I'm always eager to learn, collaborate, and take on new challenges.",
  ],
  careerObjective:
    "To obtain a career in a reputable firm to fully utilize my knowledge and skills while making a significant contribution to the growth and success of the organization.",
};

export const skills = {
  programming: [
    { name: "Python", level: 80 },
    { name: "C#", level: 70 },
    { name: "Java", level: 72 },
    { name: "C++", level: 65 },
    { name: "JavaScript", level: 68 },
  ],
  web: [
    { name: "HTML", level: 85 },
    { name: "CSS", level: 78 },
    { name: "React", level: 60 },
  ],
  tools: [
    { name: "Git", level: 70 },
    { name: "Firebase", level: 65 },
    { name: "MySQL", level: 72 },
    { name: "Tauri", level: 50 },
    { name: "MS Office", level: 80 },
  ],
  os: [
    { name: "Windows", level: 90 },
    { name: "Linux", level: 65 },
    { name: "MacOS", level: 60 },
  ],
  soft: [
    "Team Player",
    "Empathetic",
    "Good Listener",
    "Quick Learner",
    "Problem Solver",
  ],
};

export const projects = [
  {
    id: "1",
    title: "IoT-Based Smart Bus Tracking & Driver Behavior Monitoring",
    description:
      "A comprehensive IoT system that enables real-time tracking of buses and monitors driver behavior for enhanced passenger safety. The system uses GPS modules, accelerometers, and cloud connectivity to provide live tracking data and behavioral analytics.",
    techStack: ["Python", "Firebase", "IoT Sensors", "GPS Module", "Raspberry Pi"],
    image: "/assets/projects/bus_tracking.png",
    liveUrl: "",
    githubUrl: "https://github.com/Asraaaay",
    featured: true,
    category: "IoT",
  },
  {
    id: "2",
    title: "IoT-Based Fire Extinguisher System",
    description:
      "An automated fire detection and extinguishing system using IoT sensors and microcontrollers. Features real-time temperature monitoring, smoke detection, and automatic activation of fire suppression mechanisms with instant alerts.",
    techStack: ["C++", "Arduino", "IoT Sensors", "Firebase"],
    image: "/assets/projects/fire_extinguisher.png",
    liveUrl: "",
    githubUrl: "https://github.com/Asraaaay",
    featured: false,
    category: "IoT",
  },
];

export const education = [
  {
    id: "1",
    type: "education",
    title: "Bachelor of Computer Applications (BCA)",
    organization: "Amrita Vishwa Vidyapeetham",
    duration: "2023 – 2026",
    description: "Pursuing a comprehensive degree in Computer Applications with focus on programming, databases, and software development.",
    score: "CGA: 5.65",
  },
  {
    id: "2",
    type: "education",
    title: "Higher Secondary (Class XII)",
    organization: "Indian School Sohar",
    duration: "2022",
    description: "Completed higher secondary education under CBSE board with a focus on science and mathematics.",
    score: "65%",
  },
  {
    id: "3",
    type: "education",
    title: "High School (Class X)",
    organization: "Indian School Sohar",
    duration: "2020",
    description: "Completed high school education under CBSE board with strong academic performance.",
    score: "71%",
  },
];

export const certifications = [
  {
    id: "1",
    title: "Basics of Python",
    issuer: "Infosys Springboard",
    icon: "Code",
  },
  {
    id: "2",
    title: "Database and SQL",
    issuer: "Infosys Springboard",
    icon: "Database",
  },
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "About", href: "#about" },
  { label: "Skills", href: "#skills" },
  { label: "Projects", href: "#projects" },
  { label: "Education", href: "#education" },
  { label: "Contact", href: "#contact" },
];

export const contactFormFields = [
  { name: "name", label: "Your Name", type: "text", placeholder: "John Doe", required: true },
  { name: "email", label: "Your Email", type: "email", placeholder: "john@example.com", required: true },
  { name: "message", label: "Your Message", type: "textarea", placeholder: "Hello Asray, I'd like to connect...", required: true },
];
